<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditVisible"
  (nzVisibleChange)="onIsNewEditVisibleChange($event)"
  [nzTitle]="selectedItem ? 'Edit Company' : 'Add New Company'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Name</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <div class="horizontal">
            <input nz-input formControlName="title" id="title" [placeholder]="'Company name'" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="industry">Industry</nz-form-label>
        <nz-form-control>
          <div class="horizontal">
            <input
              placeholder="Industry"
              nz-input
              formControlName="companyType"
              id="companyType"
              (ngModelChange)="onCompanyCategoryChange($event)"
              [nzAutocomplete]="auto"
            />
            <nz-autocomplete [nzDataSource]="companyCategoryFilteredOptions" #auto></nz-autocomplete>
            <a
              nz-button
              nzType="default"
              nzSize="small"
              [nzLoading]="isGetIndustryLoading()"
              (click)="onGetIndustryClick()"
              >Auto Analyze Industry</a
            >
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="websiteUrl">Website</nz-form-label>
        <nz-form-control>
          <div class="horizontal">
            <input nz-input formControlName="websiteUrl" id="websiteUrl" [placeholder]="'Website URL'" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="description">Description</nz-form-label>
        <nz-form-control>
          <div class="horizontal">
            <textarea
              [rows]="7"
              nz-input
              formControlName="description"
              id="description"
              [placeholder]="'Company description'"
            ></textarea>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <div *nzModalFooter class="full-width horizontal seperate">
    <button
      nz-button
      nzType="default"
      [nzDanger]="true"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure you want to delete?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="onDeleteClick()"
    >
      Delete
    </button>

    <div class="horizontal">
      <button nz-button nzType="default" (click)="onCancelClick()">Cancel</button>
      <button nz-button nzType="primary" (click)="submitForm()">{{ selectedItem ? 'Save' : 'Create' }}</button>
    </div>
  </div>
</nz-modal>
